module.exports = __webpack_public_path__ + "static/media/inverter.d0414b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/inverter.png
// module id = 477
// module chunks = 0